export default "__VITE_ASSET__bHuab9ua__"